class RecentlyViewedProductsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.storageKey = 'theme:recently-viewed-products'
    this.limit = Number(this.dataset.limit) || 12
    this.cartView = this.dataset.view === 'cart-cards' ? true : false

    this.storeCurrentProduct()
    this.loadProducts()
  }

  /**
   * Store current product handle in localStorage
   */
  storeCurrentProduct () {
    if (!window.recentlyViewedProduct?.handle) return

    try {
      const existing = new Set(
        JSON.parse(localStorage.getItem(this.storageKey) || '[]'),
      )

      existing.delete(window.recentlyViewedProduct.handle)
      existing.add(window.recentlyViewedProduct.handle)

      localStorage.setItem(
        this.storageKey,
        JSON.stringify(Array.from(existing).reverse()),
      )
    } catch (e) {
      // Safari private mode fallback
    }
  }

  /**
   * Load recently viewed products
   */
  async loadProducts () {
    let handles = []

    try {
      handles = JSON.parse(localStorage.getItem(this.storageKey) || '[]')
    } catch (e) {
      this.hidden = true
      return
    }

    const currentHandle = window.recentlyViewedProduct?.handle

    // Out of stock products can be hidden, so fetch extra to replace them
    const fetchLimit = this.limit * 2

    handles = handles
      .filter(handle => handle && handle !== currentHandle)
      .slice(0, fetchLimit)

    // Hide entire component if no products
    if (!handles.length) {
      this.hidden = true
      return
    }

    let template = 'recently-viewed'

    if (this.cartView === true) {
      template = 'recently-viewed-cart'
    }

    const requests = handles.map(handle =>
      fetch(`/products/${handle}?view=${template}`)
        .then(res => {
          if (!res.ok) throw new Error('Fetch failed')
          return res.text()
        })
        .then(html => {
          // Empty when the product is hidden for being out of stock
          if (!html.trim()) return ''

          return `
            <div class="sec-RecentlyViewedProducts_Slide keen-slider__slide">
              ${html}
            </div>
          `
        })
        .catch(() => ''),
    )

    const slides = await Promise.all(requests)

    const html = slides.filter(Boolean).slice(0, this.limit).join('').trim()

    // Hide if all fetches failed
    if (!html) {
      this.hidden = true
      return
    }

    // Ensure component is visible
    this.hidden = false

    this.els.slides.element.innerHTML = html

    if (this.cartView === true) {
      return
    }

    this.initCarousel()
  }

  /**
   * Initialise Keen Slider
  */

  initCarousel () {
    const KeenSlider = window.KeenSlider

    if (!KeenSlider) return

    const getPerView = () => {
      if (this.cartView == true) {
        return 1.2
      }

      const width = this.els.slides.element.clientWidth

      if (width < 450) return 1.6
      if (width < 650) return 2
      if (width < 900) return 3

      return 4
    }

    const createSlider = () => {
      if (this.carousel) {
        this.carousel.destroy()
      }

      this.carousel = new KeenSlider(
        this.els.slides.element,
        {
          loop: false,
          mode: 'snap',
          rubberband: false,
          slides: {
            perView: getPerView(),
            spacing: 12,
          },
        },
        [
          window.BAO.carousel.useInitialised(),
          window.BAO.carousel.useArrows({
            next: this.els?.next?.element,
            previous: this.els?.previous?.element,
          }),
        ],
      )
    }

    createSlider()

    const resizeObserver = new ResizeObserver(() => {
      createSlider()
    })

    resizeObserver.observe(this.els.slides.element)
  }
}

customElements.define(
  'recently-viewed-products-carousel',
  RecentlyViewedProductsCarousel,
)
